import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import { SelectContact } from '../Contacts/selectContact';
import ContractTemplate from '../Contracts/contractTemplate'
import contractServices from '../Contracts/contractServices';
import WizardServices from './WizardServices';
import { LabelListing } from '../Imprint/label';
import cachingMechanisum from '../Common/cachingMechanisum';

export function ContractWizardInfo(MainWizard: any) {


    console.log(MainWizard)
    let [filedData] = useState<any[]>([]);
    let [isOpen, setIsOpen] = useState(false);
    let [contactType, setcontactType] = useState('');
    let [activeTabParty, setactiveTabParty] = useState(false);
    let [conAdditional, setcontractAdditional] = useState<any>([]);
    let [selectTemplate, initselectTemplate] = useState<any>([]);
    let [copyTemplate, setcopyTemplate] = useState(false)
    let [lookUpTypeList, setlookUpTypeList] = useState<any>([]);

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        console.log(Field_name)
        if (Field_type === "checkbox") {
            Field_value = !(conAdditional[Field_name]);
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...conAdditional };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        conAdditional = updatedObject;
        setcontractAdditional(conAdditional);

    };

    const fieldSelectUpdate = (fieldName: any, value: any) => {
        setcontractAdditional({ ...conAdditional, [fieldName]: value })
    }

    const onChangeContactParty = (e: any, error: any) => {
        console.log(e)
        console.log(error)
        console.log(contactType)

        if (contactType === 'Party') {
            if (e.type === "kontact") {
                setcontractAdditional((prevDetails: any) => ({
                    ...prevDetails, contractingParty: e.data.kontactDisplay,
                    contractingPartyImage: e.data.creatorImage,
                    contractArtist: e.data.kontactDisplay, contractArtistFlag: e.type
                }));

                console.log(conAdditional)
            } else if (e.type === "Imprint") {
                setcontractAdditional((prevDetails: any) => ({
                    ...prevDetails, contractingParty: e.data.companyName,
                    contractingPartyImage: e.data.image,
                    contractArtist: e.data.companyName, contractArtistFlag: e.type
                }));
            }
        }


        if (contactType === 'Entity') {
            if (e.type === "kontact") {
                setcontractAdditional((prevDetails: any) => ({
                    ...prevDetails, legalEntity: e.data.kontactDisplay,
                    legalEntityImage: e.data.creatorImage,
                    contractArtist: e.data.kontactDisplay, contractArtistFlag: e.type
                }));
            } else if (e.type === "Imprint") {
                setcontractAdditional((prevDetails: any) => ({
                    ...prevDetails, legalEntity: e.data.companyName,
                    legalEntityImage: e.data.image,
                    contractArtist: e.data.companyName, contractArtistFlag: e.type
                }));
            }
        }


        activeTabParty = false;
        setactiveTabParty(activeTabParty)


    }

    const selectedTemplate = (n: any) => {
        initselectTemplate(n)
        copyTemplate = false;
        setcopyTemplate(copyTemplate)
    }

    const SaveContract = () => {
        FormValidation();
    }

    const FormValidation = () => {
        const valid = false;

        const contractingPartyElement: any = document.getElementById("contractingParty");
        const contractTitleElement: any = document.getElementById("contractTitle");
        const basicElement: any = document.getElementById("basic");

        contractingPartyElement.style.border = "1px solid #DEDEDE";
        contractTitleElement.style.border = "1px solid #DEDEDE";
        basicElement.style.border = "1px solid #DEDEDE";

        if (!(conAdditional.contractingParty)) { contractingPartyElement.style.border = "1px solid #e50e0e"; }
        if (!(conAdditional.contractTitle)) { contractTitleElement.style.border = "1px solid #e50e0e"; }
        if (!(conAdditional.contractType)) { basicElement.style.border = "1px solid #e50e0e"; }

        if ((conAdditional.contractingParty) && (conAdditional.contractingParty.length === 0)) { contractingPartyElement.style.border = "1px solid #e50e0e"; }
        if ((conAdditional.contractTitleElement) && (conAdditional.contractTitleElement.length === 0)) { contractTitleElement.style.border = "1px solid #e50e0e"; }
        if ((conAdditional.contractType) && (conAdditional.contractType.length === 0)) { basicElement.style.border = "1px solid #e50e0e"; }

        return valid;
    }


    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code.contractRefNum) {

            WizardServices.contractscontractRefNum(MainWizard.data.code.contractRefNum).then((value: any) => {
                setcontractAdditional(value)
            })
        }


        lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType");
        setlookUpTypeList(lookUpTypeList)
    }, []);

    const onchangeImprint = (e: any) => {
        console.log(e)
        fieldSelectUpdate('shortLabel', e.useFreeText)

        setIsOpen(false)
    }

    const closeLabelListing = (e: any) => {
        setIsOpen(false)
    }

    return (
        <>
            <div className="ws-12 ps">
                <div className="box" >
                    <div className="box-header">  <h3>New Contract</h3> </div>

                    <div className="box-content">
                        <div className="alert hide" ng-show="contractSavedSuccessfully">Contract {MainWizard.data.code.contractRefNum} Saved Successfully </div>

                        <div className="ws-12" style={{ width: "100%" }}>
                            <div className="ws-1" style={{ width: "18%" }}>
                                <div className="text-center pull-left">
                                    <i className="zFront" style={{ left: "0" }}> </i>

                                    {conAdditional.legalEntityImage && <img alt="Korrect"  src={conAdditional.legalEntityImage} style={{ width: "80px", height: "50px;" }} />}
                                    {!conAdditional.legalEntityImage && <i className="icon-pictures1 primary positionRelative" style={{ fontSize: "43px" }}></i>}
                                </div>
                            </div>

                            <div className="form-format ws-3">
                                <label className="control-label ws-6 text-left" >Legal Entity</label>
                                <div className="label-entries ws-11">
                                    <div className="ws-10">
                                        <input type="text" id="shortLabel" disabled={true} value={conAdditional.legalEntity} name="contractArtistDisplay" placeholder="Legal Entity" />
                                    </div>

                                    <div className="ws-2">
                                        <button type="button" className="icon-btn edit width50 height35" onClick={() => { setactiveTabParty(true); setcontactType("Entity") }}><i className="icon-user-add"></i></button>
                                    </div>
                                </div>
                            </div>

                            <div className="ws-1" style={{ marginLeft: "3.5%" }}>
                                <div className="text-center pull-left">
                                    <i className="zFront" style={{ left: "0" }}> </i>
                                    {conAdditional.contractingPartyImage && <i className="ws-2 plx" ><img alt="Korrect"  src={conAdditional.contractingPartyImage} style={{ width: "80px", height: "50px;" }} /></i>}
                                    {!conAdditional.contractingPartyImage && <i className="icon-pictures1 primary positionRelative plx ws-2" style={{ fontSize: "43px" }}></i>}

                                </div>
                            </div>

                            <div className="form-format ws-4">
                                <label className="control-label ws-5 text-left">Contracting Party*</label>

                                <div className="label-entries ws-8">
                                    <div className="ws-10">
                                        <input type="text" id="contractArtistDisplay" disabled value={conAdditional.contractingParty} name="contractArtistDisplay" placeholder="Contracting Party" />
                                    </div>

                                    <div className="ws-2">
                                        <button type="button" className="icon-btn edit width50 height35" onClick={() => { setactiveTabParty(true); setcontactType("Party") }}><i className="icon-user-add"></i></button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12">
                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label className="control-label" style={{ width: "20%" }} >Contract Ref Num</label>
                                <div className="label-entries" style={{ width: "75%" }}>
                                    <input type="text" placeholder="Contract Ref Num" id="contractRefNum" value={conAdditional.contractRefNum ? conAdditional.contractRefNum : ""} name="contractRefNum" onChange={(e) => { handleFieldChange(e) }} />
                                </div>
                            </div>

                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label className="control-label" style={{ width: "20%" }}>Contract Title*</label>
                                <div className="label-entries" style={{ width: "75%" }}>
                                    <input type="text" value={conAdditional.contractTitle ? conAdditional.contractTitle : ""} name="contractTitle" onChange={(e) => { handleFieldChange(e) }} placeholder="Contract Title" />
                                </div>
                            </div>

                            <div className="form-format ws-12" style={{ width: "88%" }}>
                                <label style={{ width: "20%" }}>Contract Party*</label>
                                <div className="label-entries" style={{ width: "75%" }}>
                                    {
                                        lookUpTypeList?.filter((value: any) => { return value.lookUpType === "ContractParties" }).map((values: any) => {
                                            return (
                                                <div className={values?.key === conAdditional?.contractParty ? "icon-btn info fill width90" : "icon-btn info width90"} onClick={() => fieldSelectUpdate('contractParty', values.key)}>
                                                    {values.value}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label style={{ width: "20%" }}>Basis*</label>
                                <div className="label-entries" style={{ width: "75%" }}>
                                    <select id="contactInfo.basis" name="contractType" onChange={(e) => { handleFieldChange(e) }}>

                                        {
                                            lookUpTypeList?.filter((value: any) => { return value.lookUpType === "Basis" }).map((values: any) => {
                                                return (
                                                    <option value={values.key} label={values.value}>{values.value}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>


                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label style={{ width: "20%" }}>Imprint</label>

                                <div className="label-entries" style={{ width: "75%" }} >
                                    <div className="ws-5">
                                        <input type="text" placeholder="Choose Imprint" className="form-control " value={conAdditional.shortLabel ? conAdditional.shortLabel : ''} id="shortLabel" />
                                    </div>
                                    <div className="ws-2">
                                        <button type="button" className="icon-btn edit width50 height35" onClick={() => setIsOpen(true)}><i className="icon-plus1"></i></button>
                                    </div>
                                    <div className="ws-5">
                                        <input type="text" className="form-control" onChange={(e) => { handleFieldChange(e) }} name="labelCodeDesc" value={conAdditional.labelCodeDesc ? conAdditional.labelCodeDesc : ''} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label className="control-label" style={{ width: "20%" }}>Description</label>

                                <div className="label-entries" style={{ width: "75%" }}>
                                    <textarea onChange={(e) => { handleFieldChange(e) }} value={conAdditional.contractDescript ? conAdditional.contractDescript : ""} placeholder="Description" name="contractDescript" > </textarea>
                                </div>
                            </div>

                            <div className="form-format ws-12" style={{ width: "90%" }}>
                                <label className="control-label" style={{ width: "20%" }}>Note Details</label>
                                <div className="label-entries" style={{ width: "75%" }}>
                                    <textarea placeholder="Note Details" onChange={(e) => { handleFieldChange(e) }} name="note" value={conAdditional.note ? conAdditional.note : ""} id="NoteDetails" ></textarea>
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label"></label>

                                <div className="label-entries" style={{ marginLeft: "20%" }}>
                                    <div className="ws-12">

                                        <div className="ws-4 text-left mbl">
                                            <label className="switch pull-left mr">
                                                <input type="checkbox" name="royaltyContract" onChange={(e) => { handleFieldChange(e) }} checked={conAdditional.royaltyContract === true ? true : false} id="royContract" />
                                                {conAdditional && conAdditional?.royaltyContract === true && <span className="slider round text-left white pm pts" >Yes</span>}
                                                {conAdditional && (conAdditional?.royaltyContract === false || !conAdditional?.royaltyContract) && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                            </label>
                                            <div className="pull-left">Royalty Contract</div>
                                        </div>

                                        <div className="ws-4">

                                            <div className="ws-12 text-left mb" >
                                                <label className="switch pull-left mr">
                                                    <input type="checkbox" name="collectorContract" onChange={(e) => { handleFieldChange(e) }} checked={conAdditional.collectorContract === true ? true : false} id="royContract" />
                                                    {conAdditional.collectorContract === true && <span className="slider round text-left white pm pts" >Yes</span>}
                                                    {(conAdditional.collectorContract === false || !conAdditional.collectorContract) && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                                </label>
                                                <div className="pull-left">Collector Contract</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="ws-12">

                                        <div className="ws-4">

                                            <div className="ws-12 text-left mb" >
                                                <label className="switch pull-left mr">
                                                    <input type="checkbox" name="publishingContract" onChange={(e) => { handleFieldChange(e) }} checked={conAdditional.publishingContract === true ? true : false} id="publContract" />
                                                    {conAdditional.publishingContract === true && <span className="slider round text-left white pm pts" >Yes</span>}
                                                    {(conAdditional.publishingContract === false || !conAdditional.publishingContract) && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                                </label>
                                                <div className="pull-left">Publishing Contract</div>
                                            </div>

                                        </div>

                                        <div className="ws-4">

                                            <div className="ws-12 text-left mb" >
                                                <label className="switch pull-left mr">
                                                    <input type="checkbox" name="mechanicalContract" onChange={(e) => { handleFieldChange(e) }} value={conAdditional.mechanicalContract} id="mechContract" checked={conAdditional.mechanicalContract === true ? true : false} />
                                                    {conAdditional.mechanicalContract === true && <span className="slider round text-left white pm pts" >Yes</span>}
                                                    {(conAdditional.mechanicalContract === false || !conAdditional.mechanicalContract) && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                                </label>
                                                <div className="pull-left">Mechanical Contract</div>
                                            </div>

                                        </div>

                                        <div className="ws-3 hide">
                                            <label className="ws-12" >Contract Template
                                                <input className="m0 mr " type="checkbox" ng-model="contractDetails.listContractTemplates" id="addressPostCode" />
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='ws-12 ptl pbl pll'>
                        {(selectTemplate.contractRefNum) && <div className='ws-10'>
                            <span style={{ color: "#47529d ", marginTop: "0px", background: "none", float: "left", fontWeight: "bold" }} className="ps">Contract Template: </span>
                            <span style={{ color: "#FFFFFF ", background: "#47529d", float: "left", borderRadius: "2px" }} className='m1 pl pt pb ws-4'>{selectTemplate.contractRefNum} - {selectTemplate.kontactDisplay}</span>
                        </div>}

                        <div className='ws-2 pull-right'>
                            {(!MainWizard.data.code.contractRefNum) && <a className="icon-btn warning width90 height35" onClick={() => setcopyTemplate(true)}>Copy</a>}
                            {<a className="icon-btn edit width90 height35" onClick={SaveContract}>Save</a>}
                        </div>
                    </div>

                </div>
            </div>

            {(() => {
                if (activeTabParty) {
                    return <SelectContact SelectContactImprint={onChangeContactParty} data={conAdditional} open={activeTabParty} />
                }

                if (isOpen) {
                    return <LabelListing onchangeImprint={onchangeImprint} data={conAdditional} closeLabelListing={closeLabelListing} open={isOpen} />
                }

                if (copyTemplate) {
                    return <ContractTemplate selectedTemplate={selectedTemplate} copyTemplate={copyTemplate} />
                }

            })()}

        </>
    );
}